<template>
  <div class="menu-box">
    <p class="top-text" v-if="showText">惬意中国生活。</p>
    <p class="top-text" v-if="showText">Ease your Chinese life.</p>
    <div class="menu-list">
      <ul>
        <li v-for="(item, index) of dataList" :key="index" @click="toPage(item.link)">
          <img class="icon" :src="item.image_url" alt="">
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      showText: {
        type: Boolean,
        default: true,
      },
      dataList: {
        type: Array,
        default: () => [],
      }
    },
    data() {
      return {
        menuList: [
          // { id: 1, image_url: require('../../assets/list/icon_1.png'), link:'http://control.jokerhu.com/apply' },
          // { id: 2, image_url: require('../../assets/list/icon_2.png'), link:'/dogCert' },
          // { id: 3, image_url: require('../../assets/list/icon_3.png'), link:'/contradiction' },
          // { id: 4, image_url: require('../../assets/list/icon_4.png'), link:'/' },
          // { id: 5, image_url: require('../../assets/list/icon_5.png'), link:'/' },
          // { id: 6, image_url: require('../../assets/list/icon_6.png'), link:'/nucleicAcid' },
          // { id: 7, image_url: require('../../assets/list/icon_7.png'), link:'/' },
          // { id: 8, image_url: require('../../assets/list/icon_8.png'), link:'/' },
        ]
      }
    },
    methods: {
      toPage(path) {
        if (path.indexOf('http') > -1) {
          window.location.href = path;
        } else {
          this.$router.push({ path });
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.menu-box{
  width: 100%;
  background-color: rgba(220, 220, 220, 0.5);
  position: absolute;
  top: 0;
  left: 100%;
  z-index: 99;
  &.show {
    animation: showBlock 0.5s ease-in-out forwards;
    @keyframes showBlock {
      0% {
        opacity: 0;
        left: 100%;
      }
      100% {
        opacity: 1;
        left: 0%;
      }
    }
  }
  .top-text {
    width: 340px;
    font-family: Oswald, sans-serif;
    text-align: left;
    color: rgb(236, 70, 104);
    text-align: center;
    &:nth-child(1) {
      font-size: 38px;
      margin: 60px auto 0;
      text-indent: 1em;
    }
    &:nth-child(2) {
      font-size: 28px;
      margin: 12px auto 40px;
    }
  }
  .menu-list {
    width: 340px;
    margin: 0 auto;
    ul {
      display: grid;
      grid-template-columns: repeat(2, calc(50% - 10px));
      grid-gap: 15px;
      padding-bottom: 60px;
      li {
        display: flex;
        flex-direction: column;
        position: relative;
        overflow: hidden;
        span {
          display: block;
          width: 100%;
          text-align: center;
          font-size: 14px;
          line-height: 1.6;
          font-family: Montserrat;
        }
        .icon {
          display: block;
          width: 100%;
        }
      }
    }
  }
}
</style>